import { useCallback } from 'react';
import { MONS_CUSTOMER_ID_SESSION } from '../constants/userManagementConstants';
import window from '../utils/window';
import useUserAccountActionsUrls from './useUserAccountActionsUrls';
import { recordCustomEventInCloudWatchRUM } from '@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum';
import { BUTTON_CLICK } from '@amzn/carrierlogistics-commons/dist/constants/analytics';
import {
  SIGN_OUT_BUTTON,
  SIGN_UP_BUTTON,
  HEADER_SIGN_IN_BUTTON,
} from '../constants/analytics';

function useUserAccountActionRedirects() {
  const { signInURL, signOutURL, signUpURL } = useUserAccountActionsUrls();

  const signInRedirect = useCallback(() => {
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: HEADER_SIGN_IN_BUTTON,
      },
    });
    window.location.href = signInURL;
  }, [signInURL]);

  const signOutRedirect = useCallback(() => {
    // removing customerID as a safe practice
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: SIGN_OUT_BUTTON,
      },
    });
    window.sessionStorage.removeItem(MONS_CUSTOMER_ID_SESSION);
    window.location.href = signOutURL;
  }, [signOutURL]);

  const signUpRedirect = useCallback(() => {
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: SIGN_UP_BUTTON,
      },
    });
    window.location.href = signUpURL;
  }, [signUpURL]);

  return {
    signInRedirect,
    signOutRedirect,
    signUpRedirect,
  };
}

export default useUserAccountActionRedirects;
